'use strict';

require('./action-list-item.less');

let defaultActionListItemController = function ($scope, defaultActionListItemControllerService) {
    defaultActionListItemControllerService.loadIntoScope($scope);
};

let getDepth = require('shared/scripts/util.getDepth.js');
let setDepth = require('shared/scripts/util.setDepth.js');

angular.module('app')
    .service('defaultActionListItemControllerService', function ($state, DataEnvironmentService, restrictUi, auth, clerkLedgerDeliverable) {

        return {
            loadIntoScope: function ($scope) {
                $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
                $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
                $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
                $scope.$state = $state;
                $scope.restrictUi = restrictUi;
                $scope.auth = auth;
                $scope.clerkLedgerDeliverable = clerkLedgerDeliverable;
            }
        }

    })
    .component('actionList',
        {
            transclude: true,
            template: require('./action-list.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('actionListItemCta',
        {
            template: require('./action-list-item-cta.html'),
            bindings: {
                action: '<',
            },
            controller: function ($scope, $state, DataEnvironmentService, auth, authProfileUpdateService) {
                $scope.$state = $state;
                $scope.dataEnvironments = DataEnvironmentService.dataEnvironments;
                $scope.activeDataEnvironment = DataEnvironmentService.activeDataEnvironment;
                $scope.setDataEnvironment = DataEnvironmentService.setDataEnvironment;
                $scope.auth = auth;

                // Support boolean item property toggle buttons

                $scope.itemPropIsTruthy = function (item, prop) {
                    return getDepth(item, prop) == true;
                };
                $scope.toggleBooleanItemProp = function (item, prop) {
                    if ($scope.itemPropIsTruthy(item, prop)) {
                        setDepth(item, prop, false);
                    } else {
                        setDepth(item, prop, true);
                    }
                    item.$update(function (data) {
                        console.log('toggleBooleanItemProp save success', data);
                    }, function (error) {
                        console.log('toggleBooleanItemProp save error', error);
                    })
                };

                /*
                 let action = {};
                 this.$onChanges = function (bindings) {
                 action = bindings.action.currentValue;
                 };
                 */

                // Support profile property buttons

                $scope.quickUpdateProfileByProp = authProfileUpdateService.quickUpdateProfileByProp;
                $scope.profilePropIs = function () {
                    return false
                };
                auth.profilePromise.then(function (profile) {
                    $scope.profilePropIs = function (prop, value) {
                        return getDepth(profile, prop) === value;
                    };
                });
            },
        })
    .component('actionListItem',
        {
            transclude: true,
            template: require('./action-list-item.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, $state, $rootScope, defaultActionListItemControllerService) {
                defaultActionListItemControllerService.loadIntoScope($scope);

                // Hocus pocus to check if the any of the action listen item action states are active

                let actionStatesToMatch = [];
                $scope.stateIncludesOneOfTheActionStates = false;

                let match = function (actions) {
                    let includes = false;
                    _.each(actions, function (action) {
                        if (!includes && $state.includes(action.state)) {
                            includes = true;
                        }
                    });
                    return includes;
                };

                this.$onChanges = function (bindings) {
                    let contents = bindings.contents.currentValue;
                    actionStatesToMatch = contents.actions;
                    $scope.stateIncludesOneOfTheActionStates = match(actionStatesToMatch);
                };

                $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                    $scope.stateIncludesOneOfTheActionStates = match(actionStatesToMatch);
                });

            },
        })
    .component('acceptTermsActionListItem',
        {
            template: require('./contents/accept-terms.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('accountingSetupActionListItem',
        {
            template: require('./contents/accounting-setup.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('activateSubscriptionActionListItem',
        {
            template: require('./contents/activate-subscription.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('addImagesAndOrPdfsOfInvoicesActionListItem',
        {
            template: require('./contents/add-images-and-or-pdfs-of-invoices.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkInvoices) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkInvoices.$activate();
                $scope.clerkInvoices = clerkInvoices;
            },
        })
    .component('addReceiptsAndOrderConfirmationsToTransactionsActionListItem',
        {
            template: require('./contents/add-receipts-and-order-confirmations-to-transactions.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTransactionRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTransactionRows.$activate();
                $scope.clerkTransactionRows = clerkTransactionRows;
            },
        })
    .component('approximatedFinancialIndicatorsActionListItem',
        {
            template: require('./contents/approximated-financial-indicators.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('banksAndAccountsActionListItem',
        {
            template: require('./contents/banks-and-accounts.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, groupedClerkAccounts, clerkAccounts) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkAccounts.$activate();
                $scope.clerkAccounts = clerkAccounts;
                $scope.groupedClerkAccounts = groupedClerkAccounts;
            },
        })
    .component('categorizePreviousAccountingWorkActionListItem',
        {
            template: require('./contents/categorize-previous-accounting-work.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('chooseSubscriptionActionListItem',
        {
            template: require('./contents/choose-subscription.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('cloudStorageActionListItem',
        {
            template: require('./contents/cloud-storage.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('currentSetupAssistWithAccountingAdminWorkActionListItem',
        {
            template: require('./contents/current-setup-assist-with-accounting-admin-work.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                $scope.loadMillieuImage = function () {
                    return require('./motin-millieu.png');
                };
            },
        })
    .component('currentSetupMoneyFlowsActionListItem',
        {
            template: require('./contents/current-setup-money-flows.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                $scope.loadMillieuImage = function () {
                    return require('./motin-millieu.png');
                };
            },
        })
    .component('currentSetupOwnAccountingAdminWorkActionListItem',
        {
            template: require('./contents/current-setup-own-accounting-admin-work.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                $scope.loadMillieuImage = function () {
                    return require('./motin-millieu.png');
                };
            },
        })
    .component('currentSetupReimbursementsActionListItem',
        {
            template: require('./contents/current-setup-reimbursements.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                $scope.loadMillieuImage = function () {
                    return require('./motin-millieu.png');
                };
            },
        })
    .component('currentSetupTimeReportingActionListItem',
        {
            template: require('./contents/current-setup-time-reporting.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                $scope.loadMillieuImage = function () {
                    return require('./motin-millieu.png');
                };
            },
        })
    .component('currentSetupTravelReimbursementsActionListItem',
        {
            template: require('./contents/current-setup-travel-reimbursements.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                $scope.loadMillieuImage = function () {
                    return require('./motin-millieu.png');
                };
            },
        })
    .component('resultingExpenseReportActionListItem',
        {
            template: require('./contents/resulting-expense-report.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkLedgerEntryRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkLedgerEntryRows.$activate();
                $scope.clerkLedgerEntryRows = clerkLedgerEntryRows;
            },
        })
    .component('resultingLedgerReportsActionListItem',
        {
            template: require('./contents/resulting-ledger-reports.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkLedgerEntryRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkLedgerEntryRows.$activate();
                $scope.clerkLedgerEntryRows = clerkLedgerEntryRows;
            },
        })
    .component('documentLedgerContentsActionListItem',
        {
            template: require('./contents/document-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('documentVatRelatedLedgerContentsActionListItem',
        {
            template: require('./contents/document-vat-related-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('historicalIncomeActionListItem',
        {
            template: require('./contents/historical-income.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('importAccountingWorkActionListItem',
        {
            template: require('./contents/import-accounting-work.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('importBankAndCreditCardTransactionsActionListItem',
        {
            template: require('./contents/import-bank-and-credit-card-transactions.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('importInvoiceInformationActionListItem',
        {
            template: require('./contents/import-invoice-information.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('importLocationDataActionListItem',
        {
            template: require('./contents/import-location-data.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('importReceiptsAndOrderConfirmationsActionListItem',
        {
            template: require('./contents/import-receipts-and-order-confirmations.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('importSpentTimeActionListItem',
        {
            template: require('./contents/import-spent-time.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inboxAccessActionListItem',
        {
            template: require('./contents/inbox-access.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inspectActiveLedgerContentsActionListItem',
        {
            template: require('./contents/inspect-active-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inspectImportedLedgerContentsActionListItem',
        {
            template: require('./contents/inspect-imported-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })

    .component('inspectIncomeTaxRelatedFiguresToReportActionListItem',
        {
            template: require('./contents/inspect-income-tax-related-figures-to-report.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inspectOrImportAccountingWorkActionListItem',
        {
            template: require('./contents/inspect-or-import-accounting-work.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inspectReportedLedgerContentsActionListItem',
        {
            template: require('./contents/inspect-reported-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inspectTheLargestLedgerContentsActionListItem',
        {
            template: require('./contents/inspect-the-largest-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inspectVatRelatedLedgerContentsActionListItem',
        {
            template: require('./contents/inspect-vat-related-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('inspectVatRelatedFiguresToReportActionListItem',
        {
            template: require('./contents/inspect-vat-related-figures-to-report.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('joinBetaChannelActionListItem',
        {
            template: require('./contents/join-beta-channel.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('ledgerEntriesCategorizationOverviewActionListItems',
        {
            template: require('./contents/ledger-entries-categorization-overview.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope,
                                  defaultActionListItemControllerService,
                                  clerkLedger) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkLedger.$activate();
                $scope.clerkLedger = clerkLedger;
            },
        })
    .component('ledgerEntriesGeneralProgressOverviewActionListItems',
        {
            template: require('./contents/ledger-entries-general-progress-overview.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope,
                                  defaultActionListItemControllerService,
                                  clerkLedger,
                                  clerkLedgers,
                                  clerkLedgerEntries,
                                  clerkTransactionRows,
                                  whereabouts,
                                  clerkInvoices) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                $scope.clerkLedger = clerkLedger;
                clerkLedgers.$activate();
                clerkLedgerEntries.$activate();
                clerkTransactionRows.$activate();
                whereabouts.$activate();
                clerkInvoices.$activate();
                $scope.clerkLedgers = clerkLedgers;
                $scope.clerkLedgerEntries = clerkLedgerEntries;
                $scope.clerkTransactionRows = clerkTransactionRows;
                $scope.whereabouts = whereabouts;
                $scope.clerkInvoices = clerkInvoices;
            },
        })
    .component('ledgersActionListItem',
        {
            template: require('./contents/ledgers.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('mapInvoiceRelatedTransactionsActionListItem',
        {
            template: require('./contents/map-invoice-related-transactions-one-by-one.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('peopleAndBusinessActionListItem',
        {
            template: require('./contents/people-and-business.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalBalanceSheetActionListItem',
        {
            template: require('./contents/personal-balance-sheet.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkLedgers) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkLedgers.$activate();
                $scope.clerkLedgers = clerkLedgers;
            },
        })
    .component('personalPreferencesActionListItem',
        {
            template: require('./contents/personal-preferences.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionsActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionsOverviewActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions-overview.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionAssistOthersActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions/assist-others.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionCompanyMoneyFlowsActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions/company-money-flows.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionKeepAuthoritiesHappyActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions/keep-authorities-happy.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionPersonalMoneyFlowsActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions/personal-money-flows.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionReimbursementsActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions/reimbursements.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionTimeReportsActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions/time-reports.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('personalServiceUsageIntentionTravelClaimsActionListItem',
        {
            template: require('./contents/personal-service-usage-intentions/travel-claims.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('receiptsAndOrderConfirmationsActionListItem',
        {
            template: require('./contents/receipts-and-order-confirmations.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('reconcileActiveLedgerContentsWithBankAccountBalancesActionListItem',
        {
            template: require('./contents/reconcile-active-ledger-contents-with-bank-account-balances.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('reconcileActiveLedgerContentsWithImportedLedgerContentsActionListItem',
        {
            template: require('./contents/reconcile-active-ledger-contents-with-imported-ledger-contents.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('recordsActionListItem',
        {
            template: require('./contents/records.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('relatePreviousAccountingWorkToSourceMaterialActionListItem',
        {
            template: require('./contents/relate-previous-accounting-work-to-source-material.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('reportOnHowTheServiceCanHelpActionListItem',
        {
            template: require('./contents/report-on-how-the-service-can-help.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('salesAndExpenseProjectionsActionListItem',
        {
            template: require('./contents/sales-and-expense-projections.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('selectBanksAndAccountsRelevantForCompanyFinancialsActionListItem',
        {
            template: require('./contents/select-banks-and-accounts-relevant-for-company-financials.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, groupedClerkAccounts, clerkAccounts) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkAccounts.$activate();
                $scope.clerkAccounts = clerkAccounts;
                $scope.groupedClerkAccounts = groupedClerkAccounts;
            },
        })
    .component('selectBanksAndAccountsRelevantForReimbursementsActionListItem',
        {
            template: require('./contents/select-banks-and-accounts-relevant-for-reimbursements.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, groupedClerkAccounts, clerkAccounts) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkAccounts.$activate();
                $scope.clerkAccounts = clerkAccounts;
                $scope.groupedClerkAccounts = groupedClerkAccounts;
            },
        })
    .component('separatePersonalVsBusinessTransactionsByArchetypesActionListItem',
        {
            template: require('./contents/separate-personal-vs-business-transactions-by-archetypes.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTransactionRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTransactionRows.$activate();
                $scope.clerkTransactionRows = clerkTransactionRows;
            },
        })
    .component('separatePersonalVsBusinessTransactionsOneByOneActionListItem',
        {
            template: require('./contents/separate-personal-vs-business-transactions-one-by-one.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTransactionRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTransactionRows.$activate();
                $scope.clerkTransactionRows = clerkTransactionRows;
            },
        })
    .component('setJournalEntryTypesForTheLargestTransactionsActionListItem',
        {
            template: require('./contents/set-journal-entry-types-for-the-largest-transactions.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTransactionRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTransactionRows.$activate();
                $scope.clerkTransactionRows = clerkTransactionRows;
            },
        })
    .component('setJournalEntryTypesForTheLargestTransactionsOneByOneActionListItem',
        {
            template: require('./contents/set-journal-entry-types-for-the-largest-transactions-one-by-one.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTransactionRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTransactionRows.$activate();
                $scope.clerkTransactionRows = clerkTransactionRows;
            },
        })
    .component('setKnowledgeAndExpertiseLevelsActionListItem',
        {
            template: require('./contents/set-knowledge-and-expertise-levels.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('setVatRelatedInvoiceInfoActionListItem',
        {
            template: require('./contents/set-vat-related-invoice-info.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkInvoices) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkInvoices.$activate();
                $scope.clerkInvoices = clerkInvoices;
            },
        })
    .component('setVatRelatedTransactionInfoActionListItem',
        {
            template: require('./contents/set-vat-related-transaction-info.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTransactionRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTransactionRows.$activate();
                $scope.clerkTransactionRows = clerkTransactionRows;
            },
        })
    .component('socialMediaActionListItem',
        {
            template: require('./contents/social-media.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('stayUpToDateWithAccountingSourceMaterialActionListItem',
        {
            template: require('./contents/stay-up-to-date-with-accounting-source-material.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkFinancialEvents) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkFinancialEvents.$activate();
                $scope.clerkFinancialEvents = clerkFinancialEvents;
            },
        })
    .component('stayUpToDateWithInvoiceInfoActionListItem',
        {
            template: require('./contents/stay-up-to-date-with-invoice-info.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkInvoices) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkInvoices.$activate();
                $scope.clerkInvoices = clerkInvoices;
            },
        })
    .component('stayUpToDateWithPayrollInfoActionListItem',
        {
            template: require('./contents/stay-up-to-date-with-payroll-info.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('stayUpToDateWithReimbursementInfoActionListItem',
        {
            template: require('./contents/stay-up-to-date-with-reimbursement-info.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('stayUpToDateWithTransactionInfoActionListItem',
        {
            template: require('./contents/stay-up-to-date-with-transaction-info.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTransactionRows) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTransactionRows.$activate();
                $scope.clerkTransactionRows = clerkTransactionRows;
            },
        })
    .component('stayUpToDateWithTravelInfoActionListItem',
        {
            template: require('./contents/stay-up-to-date-with-travel-info.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkTravelClaims) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkTravelClaims.$activate();
                $scope.clerkTravelClaims = clerkTravelClaims;
            },
        })

    .component('surveyToPrepareForImportAccountingWorkActionListItem',
        {
            template: require('./contents/survey-to-prepare-for-import-accounting-work.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('surveyToPrepareForImportBankAndCreditCardTransactionsActionListItem',
        {
            template: require('./contents/survey-to-prepare-for-import-bank-and-credit-card-transactions.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('surveyToPrepareForImportInvoiceInformationActionListItem',
        {
            template: require('./contents/survey-to-prepare-for-import-invoice-information.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('surveyToPrepareForImportLocationDataActionListItem',
        {
            template: require('./contents/survey-to-prepare-for-import-location-data.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('surveyToPrepareForImportReceiptsAndOrderConfirmationsActionListItem',
        {
            template: require('./contents/survey-to-prepare-for-import-receipts-and-order-confirmations.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('surveyToPrepareForImportSpentTimeActionListItem',
        {
            template: require('./contents/survey-to-prepare-for-import-spent-time.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })

    .component('travelClaimsActionListItem',
        {
            template: require('./contents/travel-claims.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('whereaboutsActionListItem',
        {
            template: require('./contents/whereabouts.html'),
            bindings: {
                contents: '<',
            },
            controller: defaultActionListItemController,
        })
    .component('workOnGamePlanActionListItem',
        {
            template: require('./contents/work-on-game-plan.html'),
            bindings: {
                contents: '<',
            },
            controller: function ($scope, defaultActionListItemControllerService, clerkLedgerDeliverables, clerkDeliverables) {
                defaultActionListItemControllerService.loadIntoScope($scope);
                clerkLedgerDeliverables.$activate();
                clerkDeliverables.$activate();
                $scope.clerkLedgerDeliverables = clerkLedgerDeliverables;
                $scope.clerkDeliverables = clerkDeliverables;
            },
        })
;



// WEBPACK FOOTER //
// .-dna/app/components/action-list-items/angular-components.js